<template>
  <div v-if="custDetails !== null" class="mt-4">
    <div class="card top_primary_card bg-primary font-bold text-white p-2 rounded-xl w-full">
      <div class="flex justify-between">
        <div class="flex justify-center items-center">
          <h1 class="heading-1 text-center">{{ custDetails.firstName }} {{ custDetails.lastName }}</h1>
        </div>
        <div class="text-error heading-4 cursor-pointer bg-white px-3 py-1 rounded-xl" @click="removeConfirm = true">
          <i class="fa-solid fa-trash"></i>
        </div>
      </div>
    </div>
    <div>
      <div class="lg:grid grid-cols-5 gap-4">
        <div class="col-span-2 my-4">
          <div class="card bg-white rounded-xl text-center p-3 mb-4" v-if="showBreakIsOn">
            <div class="heading-3 text-error">Shift Paused</div>
            <div class="heading-5 text-text2">{{ breakTitleVal }}</div>
            <div class="heading-6 text-text2">{{ breakNoteVal }}</div>
          </div>
          <div class="card bg-white rounded-xl text-center p-4 mb-4" :class="showBreakIsOn ? 'opacity-50' : ''">
            <div class="text-text2 heading-4">
              <span>{{ displayText }}</span><span class="pl-2 text-gray4 heading-6"
                v-if="custDetails.isForceClockOut">(Forced clocked out)</span>
            </div>
            <div class="mt-2">
              <p class="text-text2 heading-1">{{ totalTimeValue | ConvertMinutesInHoursAndMinutes }}</p>
            </div>
            <p class="text-gray4 heading-6 mt-2">Excluding breaks</p>
            <div v-if="custDetails.selfieList !== null" class="">
              <div class="flex gap-4 justify-between" style="flex-wrap: wrap;">
                <div class="card rounded-xl border-t border-gray-100 bg-white attachment-card cursor-pointer"
                  style="width: 80px; height: 80px" v-for="(attach, a) in custDetails.selfieList" :key="a"
                  @click="showFullImage(attach)">
                  <div class="text-center">
                    <img style="height: 60px;width: 120px;object-fit: contain;" :src="attach.selfiePath"
                      class="scroll-img-view">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card bg-white rounded-xl p-4 mb-4">
            <div class="">
              <div class="text-text2 heading-4 flex items-center justify-between" :class="TotalBreak > 0 ? '' : ''">
                <span>Breaks Taken</span>
                <div @click="openBreadkDetail = !openBreadkDetail"
                  class="pl-2 text-primary cursor-pointer heading-4 flex items-center" v-if="custDetails.breakList.length > 0">
                  <span>{{ TotalBreak | ConvertMinutesInHoursAndMinutes }}</span>
                  <span v-if="!openBreadkDetail" class="text-primary pl-2"><i class="fas fa-chevron-down"></i></span>
                  <div v-if="openBreadkDetail" class="text-primary pl-2"><i class="fas fa-chevron-up"></i></div>
                </div>
                <span class="pl-2 text-text2 heading-4" v-if="custDetails.breakList.length === 0">No Break</span>
              </div>
              <div class="" v-if="openBreadkDetail">
                <div class="bg-white card rounded p-2 m-4 mt-0 mb-1" v-for="(data, index) in custDetails.breakList" :key="index">
                  <div v-if="data.breakEndTime !== ''">
                    <div class="text-right text-gray4 heading-5">{{ data.displayText }}</div>
                    <div class="flex items-start justify-between">
                      <div>
                        <p class="text-text2 heading-4 pl-2">{{ data.breakTitle === '' ? '-' : data.breakTitle }}</p>
                        <p class="text-text2 heading-6 pl-2" v-if="data.notes !== ''">{{data.notes}}</p>
                      </div>
                      <p class="text-gray4">{{ data.totalTimeInMin | ConvertMinutesInHoursAndMinutes }}</p>
                    </div>
                  </div>
                  <div v-if="data.breakEndTime === ''">
                    <div class="text-right text-gray4 heading-5">{{ data.breakStartTime | getStringData}}</div>
                    <div class="flex items-start justify-between">
                      <div>
                        <p class="text-text2 heading-4 pl-2">{{ data.breakTitle === '' ? '-' : data.breakTitle }}</p>
                        <p class="text-text2 heading-6 pl-2" v-if="data.notes !== ''">{{data.notes}}</p>
                      </div>
                      <p class="text-secondary">Ongoing Break</p>
                    </div>
                  </div>
                  <div v-if="data.selfieList !== null">
                    <div class="flex gap-4" style="flex-wrap: wrap;">
                      <div class="card rounded-xl border-t border-gray-100 bg-white attachment-card cursor-pointer"
                        style="width: 60px; height: 60px" v-for="(attach, a) in data.selfieList" :key="a"
                        @click="showFullImage(attach)">
                        <div class="text-center">
                          <img style="height: 50px;width: 100px;object-fit: contain;" :src="attach.selfiePath"
                            class="scroll-img-view">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card bg-white rounded-xl p-4 mb-1">
            <span class="text-text2 heading-4">Location Tracking:</span>
            <div class="relative pt-2">
              <gmap-map ref="gmap" :center="center" :zoom="11" map-type-id="hybrid" :options="{
                scrollwheel: true,
                zoomControl: true,
                tilt: 0,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: true,
                rotateControl: true,
                fullscreenControl: true
              }" style="width: 100%;height: 50vh;">
                <GmapMarker :position="center" :clickable="true" />
              </gmap-map>
              
              <!-- LEGEND BELOW MAP -->
              <div class="mt-3 bg-gray-50 rounded-lg px-3 py-2">
                
                <div class="legend-row">
                  
                  <!-- Work Segment (always shown if exists) -->
                  <div v-if="workSegment" class="legend-item">
                    <span 
                      class="legend-dot" 
                      :style="{ backgroundColor: workSegment.displayColor || '#3b82f6' }"
                    ></span>
                    <span class="legend-text">Work</span>
                  </div>

                  <!-- Consolidated Breaks Legend (single item for ALL breaks) -->
                  <div v-if="breakSegments.length > 0" class="legend-item">
                    <span 
                      class="legend-dot" 
                      :style="{ 
                        backgroundColor: breakLegendColor,
                        backgroundImage: breakSegments.length > 1 ? 'linear-gradient(135deg, #f59e0b 25% 75%)' : 'none',
                        backgroundSize: breakSegments.length > 1 ? '4px 4px' : 'auto'
                      }"
                    ></span>
                    <span class="legend-text">
                      Break{{ breakSegments.length > 1 ? 's' : '' }} 
                      <span class="text-gray4 font-normal">({{ breakSegments.length }})</span>
                    </span>
                  </div>

                  <!-- Divider -->
                  <div class="legend-divider"></div>

                  <!-- Static: Shift Start/End -->
                  <div class="legend-item">
                    <span class="legend-dot bg-green-500"></span>
                    <span class="legend-text">Shift Start</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-dot bg-red-500"></span>
                    <span class="legend-text">Shift End</span>
                  </div>

                  <!-- Empty state -->
                  <div v-if="userLocation.length === 0" class="legend-empty text-xs">
                    No location data
                  </div>
                </div>
              </div>
              
              <div class="mt-3" v-if="userLocation.length > 0">
                <div
                  v-for="(item, index) in userLocation"
                  :key="index"
                  class="flex items-center gap-2 mb-1 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    :id="'track_' + index"
                    v-model="item.isDrawPoly"
                    @change="filterByDevice(item, index)"
                  />
                  <label
                    :for="'track_' + index"
                    class="heading-6 cursor-pointer font-semibold"
                    :style="{ color: item.displayColor || '#888888' }"
                  >
                    {{ item.breakTitle !== '' ? 'Break' : 'Work Segment' }}
                    <span class="text-gray4 font-normal pl-1">{{ formatSegmentTime(item.startTime, item.endTime) }}</span>
                     <span v-if="item.breakNotes" class="text-xs text-gray4 italic ml-1">
                        {{ item.breakNotes }}
                      </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-3 my-4" v-if="canNotePermission">
          <div class="card rounded-xl bg-white mb-4 p-4">
            <NotesList :detailId="parseInt(this.$route.params.shiftId)" :requestType="'shift'" :noteTitle="'Shift Note'" />
          </div>
        </div>
        <div class="col-span-3 my-4" v-else>
          <div class="card rounded-xl bg-white mb-4 p-4">
            <p class="heading-6 text-gray4">You Dont have permission to show Shift Note</p>
          </div>
        </div>
      </div>
    </div>
    <FullImage v-if="shoFullImage" :fileObject="fileObject" />
    <div v-if="removeConfirm" class="popup_overlay relative px-4">
      <div style="width: 500px;" class="custom_dialog rounded-xl h-min p-4">
        <div class="mb-5 font-bold">
          <p class="heading-3 text-text1">Are you sure?</p>
        </div>
        <div class="mb-5 font-bold">
          <p class="heading-6 text-text1 mb-4">Once deleted cannot undone.</p>
        </div>
        <div class="flex gap-2 justify-end">
          <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Cancel'" @buttonAction="removeConfirm = false"/>
          <Button :btnSize="'medium'" :textColor="'white'" :btnColor="'error'" :btnText="'Delete'" @buttonAction="deleteShift"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global google */
import Button from '@/View/components/globalButton.vue'
import {FilterPermissions} from '@/utils/Permissions.js'
import {getDisplayText} from '@/utils/convertDateAndTime.js'
import NotesList from '@/View/job/visit/NotesList.vue';
import FullImage from './FullImage.vue'
import Vue from 'vue'
import store from '@/store'
import * as VueGoogleMaps from 'vue2-google-maps'
var moment = require('moment')
import MyJobApp from "@/api/MyJobApp.js";

Vue.use(VueGoogleMaps, {
  load: {
    key: store.getters.googleMapApiKey,
    libraries: 'places,drawing'
  }
})

export default {
  name: "customer",
  components: {
    Button,
    FullImage,
    NotesList
  },
  data() {
    return {
      showBreakIsOn: false,
      breakTitleVal: '',
      breakNoteVal: '',
      canNotePermission: FilterPermissions('shift_notes'),
      removeConfirm: false,
      pathMarker: [],
      flightPath: [],
      userLocation: [],
      center: { lat: 18.60215033927151, lng: 73.75374753105622 },
      activeIndex: 0,
      openBreadkDetail: false,
      totalTimeValue: 0,
      fileObject: {},
      shoFullImage: false,
      displayText: '',
      TotalBreak: 0,
      contactDetailForUpdate: null,
      deleteSelectId: null,
      updatesContact: false,
      delteAddressConfirm: false,
      updateCompanyName: false,
      addAddress: false,
      custDetails: null,
      shiftStartTime: null,
      shiftEndTime: null,
    };
  },
  created() { },
  computed: {
    workSegment() {
      return this.userLocation.find(s => !s.breakTitle);
    },
    breakSegments() {
      return this.userLocation.filter(s => s.breakTitle);
    },
    // Check if any break is currently visible on map
    hasVisibleBreaks() {
      return this.breakSegments.some(b => b.isDrawPoly);
    },
    // Get a representative color for the consolidated break legend
    breakLegendColor() {
      return this.breakSegments[0]?.displayColor || '#f59e0b'; // Amber default
    }
  },
  mounted() {
    this.getCustDetails();
    this.$watch('custDetails', (newVal) => {
      if (newVal && newVal.userDetailId) {
        // Store shift times for client-side filtering
        this.shiftStartTime = newVal.shiftStartTime ? new Date(newVal.shiftStartTime) : null;
        this.shiftEndTime = newVal.shiftEndTime ? new Date(newVal.shiftEndTime) : null;
        // Now fetch location history
        this.getHistoryLocationDetail();
      }
    }, { immediate: true });
    
    this.$root.$on('fullScreenSelfies', (response) => {
      if (response) {
        this.getCustDetails();
        this.shoFullImage = false;
      }
      document.body.style = 'overflow: visible;';
      this.shoFullImage = false;
    });
  },
  methods: {
    formatSegmentTime(startTime, endTime) {
      let start = startTime ? moment(startTime).format('hh:mm a') : '';
      let end = endTime ? moment(endTime).format('hh:mm a') : 'Ongoing';
      return start ? (start + ' - ' + end) : '';
    },
    updateContact(detail) {
      this.updatesContact = true;
      this.contactDetailForUpdate = detail;
    },
    getHistoryLocationDetail() {
      const userDetailId = this.custDetails?.userDetailId;
      // Use shift date for filtering (backend requirement)
      const date = this.shiftStartTime ? moment(this.shiftStartTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      
      this.$store.dispatch("SetLoader", { status: true, message: "Loading map...", });
      
      MyJobApp.LocationHistory(
        userDetailId,
        0, // lastLocationLogId: 0 = fetch all for date
        date,
        (response) => {
          if (response.success === 1 && response.Data) {
            let allPoints = response.Data;
            
            if (this.shiftStartTime) {
              allPoints = allPoints.filter(p => {
                const pointDate = new Date(p.addedDate);
                // Include if: after shift start AND (before shift end OR shift still ongoing)
                const afterStart = pointDate >= this.shiftStartTime;
                const beforeEnd = !this.shiftEndTime || pointDate <= this.shiftEndTime;
                return afterStart && beforeEnd;
              });
            }
            
            // STEP 2: Derive boolean flags from locationType (frontend-side)
            allPoints = allPoints.map(p => ({
              ...p,
              isShiftStart: p.locationType === 'start',
              isShiftEnd: p.locationType === 'end',
              isBreakStart: p.locationType === 'BStart',
              isBreakEnd: p.locationType === 'BEnd',
              isInProgress: p.locationType === 'inprogress'
            }));
            
            // STEP 3: Separate work vs break points
            const workPoints = allPoints.filter(p => !p.isBreakStart && !p.isBreakEnd);
            const breakPoints = allPoints.filter(p => p.isBreakStart || p.isBreakEnd);
            
            // STEP 4: Build userLocation structure expected by displayTrackingPath
            const segments = [];
            const displayColor = this.custDetails?.displayColor || '#3b82f6';
            
            // Work segment
            if (workPoints.length > 0) {
              segments.push({
                startTime: workPoints[0]?.addedDate || '',
                endTime: workPoints[workPoints.length - 1]?.addedDate || '',
                displayColor: displayColor,
                breakTitle: '',
                isDrawPoly: true,
                pathMarker: [],
                flightPath: null,
                locationList: [{
                  deviceId: 1,
                  deviceModel: '',
                  os: '',
                  osVersion: '',
                  locationLogs: JSON.stringify({
                    locationLogs: workPoints.map(p => ({
                      latitude: p.latitude,
                      longitude: p.longitude,
                      accuracy: p.accuracy,
                      addedDate: p.addedDate,
                      locationType: p.locationType,
                      isShiftStart: p.isShiftStart,
                      isShiftEnd: p.isShiftEnd,
                      isBreakStart: p.isBreakStart,
                      isBreakEnd: p.isBreakEnd,
                      isInProgress: p.isInProgress,
                      heading: p.heading || 0,
                      speed: p.speed || 0,
                      odometer: p.odometer || 0,
                      firstName: p.firstName || '',
                      lastName: p.lastName || ''
                    }))
                  })
                }]
              });
            }
            
            // Break segments (group by break events)
            if (breakPoints.length > 0) {
              // Sort breaks by time first
              breakPoints.sort((a, b) => new Date(a.addedDate) - new Date(b.addedDate));
              
              // Group break points into pairs: BStart → BEnd
              const breakSegments = [];
              let currentBreak = null;
              
              for (const point of breakPoints) {
                if (point.isBreakStart) {
                  // Start a new break segment
                  currentBreak = {
                    startTime: point.addedDate,
                    endTime: null,
                    points: [point]
                  };
                } else if (point.isBreakEnd && currentBreak) {
                  // Close the current break segment
                  currentBreak.endTime = point.addedDate;
                  currentBreak.points.push(point);
                  breakSegments.push(currentBreak);
                  currentBreak = null;
                } else if (currentBreak) {
                  // Mid-break tracking point
                  currentBreak.points.push(point);
                }
              }
              
              // Handle any unclosed break (ongoing)
              if (currentBreak && currentBreak.points.length > 0) {
                breakSegments.push(currentBreak);
              }
              
              // Create userLocation entries for each break
              const breakColors = '#f59e0b'
              
              breakSegments.forEach((breakSeg, idx) => {
                // Try to match with custDetails.breakList for title/notes
                const matchedBreak = this.custDetails?.breakList?.find(b => 
                  b.breakStartTime === breakSeg.startTime || 
                  (b.breakStartTime && new Date(b.breakStartTime).getTime() === new Date(breakSeg.startTime).getTime())
                );
                
                segments.push({
                  startTime: breakSeg.startTime,
                  endTime: breakSeg.endTime || '',
                  displayColor: breakColors,
                  breakTitle: matchedBreak?.breakTitle || `Break ${idx + 1}`,
                  breakNotes: matchedBreak?.notes || '',
                  isDrawPoly: true,
                  pathMarker: [],
                  flightPath: null,
                  locationList: [{
                    deviceId: 1,
                    deviceModel: '',
                    os: '',
                    osVersion: '',
                    locationLogs: JSON.stringify({
                      locationLogs: breakSeg.points.map(p => ({
                        latitude: p.latitude,
                        longitude: p.longitude,
                        accuracy: p.accuracy,
                        addedDate: p.addedDate,
                        locationType: p.locationType,
                        isBreakStart: p.isBreakStart,
                        isBreakEnd: p.isBreakEnd,
                        isInProgress: p.isInProgress,
                        heading: p.heading || 0,
                        speed: p.speed || 0,
                        odometer: p.odometer || 0,
                        firstName: p.firstName || '',
                        lastName: p.lastName || ''
                      }))
                    })
                  }]
                });
              });
            }
            
            this.userLocation = segments;
            
            // STEP 5: Render map after data is ready
            setTimeout(() => {
              this.displayTrackingPath();
            }, 100);
          }
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        (error) => {
          console.error('Location history error:', error);
          this.$store.dispatch("SetLoader", { status: false, message: "" });
          this.$store.dispatch('SetAlert', {
            showAlert: true,
            message: error.message || 'Failed to load location',
            color: 'error'
          });
        }
      );
    },
    
    computeHeading(from, to) {
      const toRad = deg => deg * Math.PI / 180;
      const lat1 = toRad(from.lat);
      const lat2 = toRad(to.lat);
      const dLng = toRad(to.lng - from.lng);
      const y = Math.sin(dLng) * Math.cos(lat2);
      const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
      return Math.atan2(y, x) * 180 / Math.PI;
    },
    
    displayTrackingPath(reDraw) {
      var infowindow = new google.maps.InfoWindow();
      let map = this.$refs.gmap.$mapObject;
      
      const processUser = (i) => {
        let allPoints = [];
        let list = this.userLocation[i].locationList;
        
        for (let j = 0; j < list.length; j++) {
          let locationObj = JSON.parse(list[j].locationLogs);
          let logs = locationObj.locationLogs;
          for (let k = 0; k < logs.length; k++) {
            allPoints.push({
              lat: parseFloat(logs[k].latitude),
              lng: parseFloat(logs[k].longitude),
              addedDate: logs[k].addedDate || '',
              locationType: logs[k].locationType || '',
              isShiftStart: logs[k].isShiftStart || false,
              isShiftEnd: logs[k].isShiftEnd || false,
              isBreakStart: logs[k].isBreakStart || false,
              isBreakEnd: logs[k].isBreakEnd || false,
              isInProgress: logs[k].isInProgress || false,
              heading: logs[k].heading || 0,
              speed: logs[k].speed || 0,
              originalLog: logs[k]
            });
          }
        }
        
        // Sort by time to ensure correct path direction
        allPoints.sort((a, b) => new Date(a.addedDate) - new Date(b.addedDate));
        
        let pathMarker = [];
        let color = this.userLocation[i].displayColor || '#888888';
        
        for (let p = 0; p < allPoints.length; p++) {
          // Use backend heading if available, else calculate
          let heading = allPoints[p].heading;
          if (!heading && p < allPoints.length - 1) {
            heading = this.computeHeading(allPoints[p], allPoints[p + 1]);
          }
          
          // Special marker icons based on location type (derived on frontend)
          let iconConfig = {
            // path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            path: google.maps.SymbolPath.CIRCLE,
            scale: 4,
            fillColor: color,
            fillOpacity: 1,
            strokeColor: '#ffffff',
            strokeWeight: 1,
            rotation: heading
          };
          
          if (allPoints[p].isShiftStart) {
            iconConfig = {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 10,
              fillColor: '#22c55e', // Green
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 3,
              rotation: 0
            };
          } else if (allPoints[p].isShiftEnd) {
            iconConfig = {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 10,
              fillColor: '#ef4444', // Red
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 3,
              rotation: 0
            };
          } else if (allPoints[p].isBreakStart || allPoints[p].isBreakEnd) {
            iconConfig = {
              path: google.maps.SymbolPath.CIRCLE,
              scale: 7,
              fillColor: '#f59e0b', // Amber
              fillOpacity: 1,
              strokeColor: '#ffffff',
              strokeWeight: 2,
              rotation: 45 // Diamond shape
            };
          }
          
          let mapMarker = new google.maps.Marker({
            position: new google.maps.LatLng(allPoints[p].lat, allPoints[p].lng),
            icon: iconConfig,
            map: map,
            zIndex: (allPoints[p].isShiftStart || allPoints[p].isShiftEnd) ? 10 : 1,
            title: allPoints[p].locationType
          });
          
          // Enhanced info window
          let log = allPoints[p].originalLog;
          let typeLabel = this.getLocationTypeLabel(log.locationType);
          let content = `
            <div style="min-width:200px;font-family:Arial,sans-serif;padding:8px">
              <div style="font-weight:bold;color:#1f2937;margin-bottom:4px">
                ${typeLabel}
              </div>
              <div style="color:#6b7280;font-size:12px;margin-bottom:6px">
                ${moment(allPoints[p].addedDate).format('MMM DD, YYYY • hh:mm:ss A')}
              </div>
              <div style="color:#374151;font-size:13px">
                📍 ${allPoints[p].lat.toFixed(5)}, ${allPoints[p].lng.toFixed(5)}
              </div>
              ${log.accuracy ? `<div style="color:#9ca3af;font-size:11px;margin-top:4px">Accuracy: ${log.accuracy}m</div>` : ''}
              ${log.speed > 0 ? `<div style="color:#9ca3af;font-size:11px">Speed: ${log.speed.toFixed(1)} km/h</div>` : ''}
            </div>
          `;
          
          google.maps.event.addListener(mapMarker, 'mouseover', (function(marker, html) {
            return function() {
              infowindow.setContent(html);
              infowindow.open(map, marker);
            };
          })(mapMarker, content));
          
          google.maps.event.addListener(mapMarker, 'mouseout', function() {
            infowindow.close();
          });
          
          pathMarker.push(mapMarker);
        }
        
        // Distance helper function (Haversine)
        const getDistance = (lat1, lon1, lat2, lon2) => {
          let R = 6371e3; // metres
          let phi1 = lat1 * Math.PI/180;
          let phi2 = lat2 * Math.PI/180;
          let deltaPhi = (lat2-lat1) * Math.PI/180;
          let deltaLambda = (lon2-lon1) * Math.PI/180;
          let a = Math.sin(deltaPhi/2) * Math.sin(deltaPhi/2) +
                  Math.cos(phi1) * Math.cos(phi2) *
                  Math.sin(deltaLambda/2) * Math.sin(deltaLambda/2);
          let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
          return R * c;
        };

        // Draw polyline
        let flightPaths = [];

        // Skip path for break
        if (!this.userLocation[i].breakTitle) {
          for (let p = 0; p < allPoints.length - 1; p++) {
            let p1 = allPoints[p];
            let p2 = allPoints[p + 1];
            let dist = getDistance(p1.lat, p1.lng, p2.lat, p2.lng);

            let polyIcons = [];
            // If distance > 4.5 meters (approx 15 feet), draw the center arrow
            if (dist > 4.5) {
              polyIcons.push({
                icon: {
                  path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                  scale: 2.5,
                  fillColor: color, // Dark Yellow
                  fillOpacity: 1,
                  strokeColor: '#ffffff',
                  strokeWeight: 1
                },
                offset: '50%'
              });
            }

            let segmentPath = new google.maps.Polyline({
              map: map,
              path: [ {lat: p1.lat, lng: p1.lng}, {lat: p2.lat, lng: p2.lng} ],
              strokeColor: color,
              strokeOpacity: 0.9,
              strokeWeight: 3,
              geodesic: true,
              icons: polyIcons
            });
            flightPaths.push(segmentPath);
          }
        }
        
        this.userLocation[i].pathMarker = pathMarker;
        this.userLocation[i].flightPath = flightPaths;
      };
      
      if (reDraw === undefined) {
        for (let i = 0; i < this.userLocation.length; i++) {
          processUser(i);
        }
      } else {
        processUser(reDraw);
      }
      this.setBound();
    },
    
    /**
     * Helper: Get emoji label for location type
     */
    getLocationTypeLabel(locationType) {
      const labels = {
        'start': '🟢 Shift Start',
        'end': '🔴 Shift End', 
        'BStart': '🟡 Break Start',
        'BEnd': '🟡 Break End',
        'inprogress': '📍 Moving'
      };
      return labels[locationType] || '📍 Location';
    },
    
    filterByDevice(value, index) {
      if (value.isDrawPoly === false) {
        if (value.flightPath) {
          if (Array.isArray(value.flightPath)) {
            value.flightPath.forEach(fp => fp.setMap(null));
          } else {
            value.flightPath.setMap(null);
          }
        }
        if (value.pathMarker) {
          for (let k = 0; k < value.pathMarker.length; k++) {
            value.pathMarker[k].setMap(null);
          }
        }
        this.setBound();
      } else {
        this.displayTrackingPath(index);
      }
    },
    
    setBound() {
      this.$refs.gmap.$mapPromise.then((map) => {
        let fitBoud = false;
        const bounds = new google.maps.LatLngBounds();
        for (let r = 0; r < this.userLocation.length; r++) {
          if (this.userLocation[r].isDrawPoly) {
            let list = this.userLocation[r].locationList;
            for (let j = 0; j < list.length; j++) {
              let locationObj = JSON.parse(list[j].locationLogs);
              let logs = locationObj.locationLogs;
              for (let k = 0; k < logs.length; k++) {
                fitBoud = true;
                bounds.extend({
                  lat: parseFloat(logs[k].latitude),
                  lng: parseFloat(logs[k].longitude)
                });
              }
            }
          }
        }
        if (fitBoud === true) {
          map.fitBounds(bounds);
        }
      });
    },
    
    getCustDetails() {
      this.totalTimeValue = 0;
      this.$store.dispatch("SetLoader", { status: true, message: "Loading...", });
      MyJobApp.specificShiftDetail(
        parseInt(this.$route.params.shiftId),
        (response) => {
          this.custDetails = response.Data;
          this.TotalBreak = 0;
          console.log('this.custDetails.breakList', this.custDetails.breakList);
          if (this.custDetails.breakList.length > 0) {
            for (let index = 0; index < this.custDetails.breakList.length; index++) {
              this.TotalBreak += this.custDetails.breakList[index].totalTimeInMin;
              if (this.custDetails.breakList[index].breakStartTime !== '' && this.custDetails.breakList[index].breakEndTime !== '') {
                this.custDetails.breakList[index].displayText = getDisplayText(this.custDetails.breakList[index].breakStartTime, this.custDetails.breakList[index].breakEndTime);
              } else {
                this.custDetails.breakList[index].displayText = '--';
              }
              if (this.custDetails.breakList[index].breakTitle === this.custDetails.breakTitle && this.custDetails.breakList[index].timeSheetBreakId === this.custDetails.timeSheetBreakId) {
                this.breakTitleVal = 'In ' + this.custDetails.breakTitle + ' From ' + getDisplayText(this.custDetails.breakList[index].breakStartTime, '');
                this.breakNoteVal = this.custDetails.breakList[index].notes;
                this.showBreakIsOn = true;
              } else {
                this.showBreakIsOn = false;
              }
            }
          }
          if (this.custDetails.totalTimeInMin === 0 && this.custDetails.shiftEndTime === '') {
            var today = new Date();
            var diffMs = (new Date(this.custDetails.shiftStartTime) - today);
            var diffMins = Math.abs(Math.round(((diffMs % 86400000) % 3600000) / 60000));
            console.log('diffMins', diffMins);
            this.totalTimeValue = diffMins - this.TotalBreak;
          } else {
            this.totalTimeValue = this.custDetails.totalTimeInMin - this.TotalBreak;
          }
          if (this.custDetails.shiftEndTime === '') {
            this.displayText = 'Clocked In at ' + getDisplayText(this.custDetails.shiftStartTime, '');
          } else {
            this.displayText = getDisplayText(this.custDetails.shiftStartTime, this.custDetails.shiftEndTime);
          }
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    
    deleteShift() {
      this.$store.dispatch("SetLoader", { status: true, message: "Loading...", });
      MyJobApp.specificShiftDelete(
        parseInt(this.$route.params.shiftId),
        (response) => {
          this.$router.push({name: 'shift'});
          this.$store.dispatch('SetAlert', {showAlert: true, message: response.message, color: 'success'});
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        (error) => {
          this.$store.dispatch('SetAlert', {showAlert: true, message: error.message, color: 'error'});
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    
    showFullImage(data) {
      this.fileObject = data;
      this.shoFullImage = true;
    },
    
    dateFilter(dateTime, value) {
      let checkDate = new Date(dateTime);
      let timeValue = moment(checkDate, 'ddd DD-MMM-YYYY, hh:mm a').format('hh:mm a');
      let todayDate = new Date().setHours(0, 0, 0, 0);
      var fullDate = moment(dateTime).format('MMM DD, ');
      let dayName = moment(dateTime).format('ddd');
      dateTime = new Date(dateTime).toUTCString();
      let requestDt = dateTime;
      requestDt = new Date(requestDt).setHours(0, 0, 0, 0);
      if (value === 'scheduleDate') {
        return fullDate + ' ' + dayName;
      } else if (value === 'scheduleTime') {
        return timeValue;
      } else {
        if (moment(todayDate).diff(requestDt, 'days') === 0) {
          return 'Today ' + timeValue;
        }
        let difDay = moment(todayDate).diff(requestDt, 'days');
        if (difDay > 1) {
          return fullDate + ' ' + timeValue;
        }
        if (difDay === 1) {
          return 'Yesterday ' + timeValue;
        }
      }
    },
  },
  beforeDestroy() {
    this.$root.$off("setNewTabActive");
    this.$root.$off("fullScreenSelfies");
    this.$root.$off("confirmBoxHandler");
  },
};
</script>

<style scoped>
.scroll-img-view {
  height: 104px;
}

.attachment-card {
  display: flex;
  align-items: center;
  position: relative;
}
.legend-row {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow-x: auto;       /* horizontal scroll */
  white-space: nowrap;    /* prevent wrapping */
  scrollbar-width: thin;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;         /* prevent shrinking */
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.legend-text {
  font-size: 12px;
  color: #6b7280;
}

.legend-divider {
  width: 1px;
  height: 16px;
  background: #e5e7eb;
  margin: 0 4px;
  flex-shrink: 0;
}

.legend-empty {
  font-size: 12px;
  color: #9ca3af;
  flex-shrink: 0;
}
</style>